import { createTypes, createActions } from '@wix/restaurants-redux/dist/actions/ActionCreatorHelper';
import PropTypes from 'proptypes';

const seatingActions = [
    {
        type: 'INIT_SETTINGS',
        propTypes: {
            showTitle: PropTypes.bool,
            showDescription: PropTypes.bool,
            layout: PropTypes.number,
            alignment: PropTypes.number,
            customTitle: PropTypes.string,
            customDescription: PropTypes.string,
            customButton: PropTypes.string,
            isCustomDesign: PropTypes.bool
        }
    },
    {
        type: 'RESIZE_COMPONENT',
        propTypes: {
            width: PropTypes.number,
            height: PropTypes.number
        }
    },
    {
        type: 'WINDOW_SIZE',
        propTypes: {
            width: PropTypes.number,
            height: PropTypes.number
        }
    }
];

const ACTION_PREFIX = 'SEATING_SETTINGS_';
export const types   = createTypes(seatingActions, ACTION_PREFIX);
export const actions = createActions(seatingActions, ACTION_PREFIX);
